import React, { useContext, useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { InfoContext } from '../../AM_BackGroundOP';
import { cleanPath, replaceMissingSpecsData } from './AM_ReaperConnectionSupport';
import {AMModal, dBConn} from '../../API_GET'
import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';
import SplitscreenOutlinedIcon from '@mui/icons-material/SplitscreenOutlined';
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RefreshIcon from '@mui/icons-material/Refresh';

//BUTTON FOR EXTERNAL EDITOR
// BUTTON FOR IMPORT PARALLEL (REAPER)
// Find Position in Reaper Session


export const OpenInEditorButton = (props) => {
    const { amKRASTRef } = useContext(InfoContext);
    const isElectron = window?.electronAPI?.isElectronContainer
    
    const keyfielmap = props?.keyfieldmap ? props.keyfieldmap :  {
        file: 's3_path_t',
        filename_expected: 'filename_expected'
    }

    const handleClick = () => {

        const filesToDownload = elaborateDataEditor([props.data], keyfielmap)  
        if (filesToDownload.length !== 0) {
            amKRASTRef.current.openInEditor({ filesToDownload });
        }
    }

    const isMissing = !props.data?.[keyfielmap.file]

    const style={
        opacity: isMissing ? 0.5 : 1,
        cursor: 'default', 
        padding: '0px'
    }

    const label = props.label ?? <span style={{cursor: isMissing ? 'default' : 'pointer'}}
                                    onClick={handleClick}
                                    title={props.title ?? 'Open Target file in External Editor'}
                                    >
                                        <AudioFileOutlinedIcon 
                                            color="inherit" 
                                            sx={{fontSize: props.props ?? '18px'}} 
                                        />
                                    </span>

    return isElectron ? (
        <button style={{...style, ...props.style}} className={`${props?.className ? `${props.className} ` : 'text-primary '}btn btn-sm`}>
            {label}
        </button>
    ) : null
}

export const ReaperImportParallel = (props) => {

    const { amKRASTRef } = useContext(InfoContext);
    const isElectron = window?.electronAPI?.isElectronContainer
    const keyfielmap = props.keyfieldmap ?? ImportFileParallel_keyfieldmap

    const handleClick = async () => {
        const result = await elaborationImportSourceAndTarget([props.data], keyfielmap)

        if (result.filesToDownload.length !== 0) {
            amKRASTRef.current.reaperImportSourceAndTarget(result);
        }
    }

    const isMissing = !props.data[keyfielmap.file_S] && !props.data[keyfielmap.file_T]

    const style={
        opacity: isMissing ? 0.5 : 1,
        cursor: isMissing ? 'default' : 'pointer',
        padding: '0px'
    }

    const label = props.label ?? <span style={{cursor: isMissing ? 'default' : 'pointer'}}
                                    onClick={handleClick}
                                    title={props.title ?? 'Import Source and Target files in current Reaper Session'}
                                    >
                                        <SplitscreenOutlinedIcon 
                                            color="inherit" 
                                            sx={{fontSize: props.props ?? '18px'}}
                                        />
                                    </span>

    return isElectron ? (
        <button style={{...style, ...props.style}}   className={`${props?.className ? `${props.className} ` : 'text-primary '}btn btn-sm`} >
            {label}
        </button>
    ) : null
}

export const FindAMSourceTAG = (props) => {

    const { amKRASTRef } = useContext(InfoContext);
    const isElectron = window?.electronAPI?.isElectronContainer

    const findInSession = (e) => {
        const isCtrlPressed = e.ctrlKey;
        const isShiftPressed = e.shiftKey;
        const isAltPressed = e.altKey;
        
        amKRASTRef.current.findAMSourceTAG({
            infoLine: props.data,
            ctrl: isCtrlPressed,
            shift: isShiftPressed,
            alt: isAltPressed
        });
    }
    return isElectron ? <button 
                            className="btn krast-reaper-button"
                            style={props?.style ?? {}}
                            onClick={findInSession}
                            title={`Find position in Reaper Session\n(Ctrl + click to open advanced search)`}>
                                R
                        </button> : null
}

export const AMSwitchTab = ({children}) => {
    const isElectron = window?.electronAPI?.isElectronContainer;    
    if (!isElectron) return null;
    
    const handleClick = () => {
        window?.electronAPI?.changeTab('krast');
    };
    // Clone children and add onClick handler
    return React.cloneElement(children, { onClick: handleClick });
}

export const LoginBackToKRAST = () => {

    const style = {position: 'fixed', top: '20px', right: '20px', zIndex: 1000, cursor: 'pointer'}

    return <AMSwitchTab>
        <i title="Back to KRAST" style={style} className="bi bi-back" />
    </AMSwitchTab>

}

export const elaborateDataEditor = (dataArray, keyfielmap) => {

    const filesToDownload = []
    dataArray.forEach(line => {
        if(line[keyfielmap.file]){
            const parseFile = window?.electronAPI?.path.parse(line[keyfielmap.file])
            const baseName = window?.electronAPI?.path.parse(cleanPath(line[keyfielmap.filename_expected])).name
            const targetFileName = `${baseName}[T${parseFile.name}]${parseFile.ext}`
            filesToDownload.push({s3path: line[keyfielmap.file], localfile: targetFileName})
        }
    })
    return filesToDownload
}


export const ImportFileParallel_keyfieldmap = {
        file_S: 's3_path_s',
        file_T: 's3_path_t',
        filename_expected: 'filename_expected',
        script_data_id: 'script_data_id',
        script_data_language_id: 'script_data_language_id',
        script_id: 'script_id',
        script_language_id: 'script_language_id',
        tc_code: 'constraint.krast_background',
        tc_name: 'tc_code_media'
}

const getNestedValue = (obj, path) => {
    return path.split('.').reduce((current, key) => current?.[key], obj);
}

export const elaborationImportSourceAndTarget = async (propsData, keyfieldmap = null) => {

    const info = []
    const filesToDownload = []
    const keyfielmap = keyfieldmap ?? ImportFileParallel_keyfieldmap
    const gatherInfoFileTypes = [];
    const gatherInfoFileTypesIndex = {};

    propsData.forEach((line, idx) => {

        const localS =  line[keyfielmap.file_S] ? window?.electronAPI?.path.parse(line[keyfielmap.file_S]).base : null
        const localT =  line[keyfielmap.file_T] ? window?.electronAPI?.path.parse(line[keyfielmap.file_T]).base : null

        if(line[keyfielmap.file_S]){
            filesToDownload.push({s3path: line[keyfielmap.file_S], localfile: localS})
        }
        
        if(line[keyfielmap.file_T]){
            filesToDownload.push({s3path: line[keyfielmap.file_T], localfile: localT})
        }

        const parseFileS = localS ? window?.electronAPI?.path.parse(line[keyfielmap.file_S]) : null
        const baseNameS = window?.electronAPI?.path.parse(cleanPath(line[keyfielmap.filename_expected])).name
        const targetFileNameS = parseFileS ? `${baseNameS}[S${parseFileS.name}]${parseFileS.ext}` : null

        const parseFileT = localT ? window?.electronAPI?.path.parse(line[keyfielmap.file_T]) : null
        const baseNameT = window?.electronAPI?.path.parse(cleanPath(line[keyfielmap.filename_expected])).name
        const targetFileNameT = parseFileT ? `${baseNameT}[T${parseFileT.name}]${parseFileT.ext}` : null
        let specsAudio = null
        if(line?.samplerate_exp){

            specsAudio = {
                samplerate: line.samplerate_exp,
                bitdepth: line.bitdepth_exp,
                channels: line.channels_exp
            }
        } else {
            specsAudio = null
            gatherInfoFileTypesIndex[idx] = line.fileTypeId
            gatherInfoFileTypes.push(line.fileTypeId)
        }

        info.push({
            script_data_id: getNestedValue(line, keyfielmap.script_data_id),
            script_data_language_id: getNestedValue(line, keyfielmap.script_data_language_id),
            script_id: getNestedValue(line, keyfielmap.script_id),
            script_language_id: getNestedValue(line, keyfielmap.script_language_id),
            tc_code: getNestedValue(line, keyfielmap.tc_code),
            target_id: line[keyfielmap.file_T] ? window?.electronAPI?.path.parse(line[keyfielmap.file_T]).name : null,
            source: {filename: targetFileNameS, s3path: line[keyfielmap.file_S], localfile: localS},
            target: {filename: targetFileNameT, s3path: line[keyfielmap.file_T], localfile: localT},
            tc_name: line?.[keyfielmap.tc_name],
            specsAudio: specsAudio,
            tempSpecsId: idx
        })
    })
    if(gatherInfoFileTypes.length > 0){

        const sortFiletypes = [...new Set(gatherInfoFileTypes)]
        const fileTypesInfo = await dBConn('krastAM-recovery-targetFileTypeInfo', sortFiletypes)
        if(fileTypesInfo.success && fileTypesInfo.data.length > 0){

            // map filetypes
            const fileTypeMap = {};
            fileTypesInfo.data.forEach(fileType => {
                fileTypeMap[fileType.id] = {
                    samplerate: replaceMissingSpecsData(fileType.specs_samplerate, 48000),
                    bitdepth: replaceMissingSpecsData(fileType.specs_bitdepth, 16),
                    channels: replaceMissingSpecsData(fileType.specs_channels, 1)
                };
            });
            
            Object.keys(gatherInfoFileTypesIndex).forEach(idx => {
                const fileTypeId = gatherInfoFileTypesIndex[idx];
                if(fileTypeMap[fileTypeId]){
                    info[idx].specsAudio = fileTypeMap[fileTypeId];
                }
            });
        }
    }

    return {info, filesToDownload}
}


export const FileTypesSelector = forwardRef((props, ref) => {

    const defaultState = {
        showModal: false,
        data: null,
        alertMessage: null,
        process: false

    }
    const [fTSel, setFTSel] = useState(defaultState);

    useImperativeHandle(ref, () => ({
        openModal(props, alertMessage = null) {
            setFTSel(p => ({
                ...p, 
                showModal: true,
                data: props,
                alertMessage: alertMessage
            }))
        }
    }))

    const preRequest = () => {
        // prerequest
        props.updatedDatakamFileTypesMap()
    }

    const handleRadioChange = (scriptId, type, filetypeId) => {
        setFTSel(prev => {
            const newData = JSON.parse(JSON.stringify(prev.data));
            
            // Reset all defaults for this script and type
            newData[scriptId][type].forEach(ft => {
                ft.default = false;
            });
            
            // Set the selected one as default
            const selected = newData[scriptId][type].find(ft => ft.id === filetypeId);
            if(selected) {
                selected.default = true;
            }
            
            return {...prev, data: newData};
        });
    };

    const apply = () => {

        setFTSel(p => ({
            ...p,
            process: true
        }))

        dBConn('krast-save-user-filetypessettings', fTSel.data).then(response => {
            if(response.success) {
                props.updateNewDatakamFileTypesMap(fTSel.data)
                closeModal();
            }
        })  
    }


    const closeModal = () => {
        setFTSel(p => defaultState)
    }


    return <>{fTSel.showModal && 
    <AMModal
        closeHandler={!fTSel.process ? closeModal : null}
        header_title={<><SettingsInputCompositeIcon style={{fontSize: '16px', marginRight: '4px'}}/> Map FileTypes</>}
        size="lg"
        buttons={<button style={{minWidth: '110px'}} 
                    className="btn btn-primary btn-sm" 
                    onClick={apply}
                    disabled={fTSel.process}>
                    Apply {fTSel.process && <div className="spinner-border text-light" style={{width: '16px', height: '16px', marginLeft: '4px'}} role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                    }
                </button>
        }
        >

            <div className="card-body p-0" style={{fontSize: '13px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto'}}>
                {fTSel.alertMessage && (
                    <div className="alert alert-warning mb-3" role="alert">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        {fTSel.alertMessage}
                    </div>
                )}
                <div className="card-text ">
                    <i>Map Source and Target FileTypes for audio operation</i>
                </div>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Script</th>
                            <th>Source</th>
                            <th>Target</th>
                        </tr>
                    </thead>
                    <tbody>
                        {fTSel.data && Object.keys(fTSel.data).map((scriptId, idx) => {
                            const s = fTSel.data[scriptId];
                            return (
                                <tr key={scriptId}>
                                    <td width="60%" className="align-middle">{s.script_name}</td>
                                        <td className="align-middle">
                                            <div>
                                                {s.source && s.source.map((src, srcIdx) => {
                                                    return (
                                                        <div key={srcIdx} className="form-check" style={{minHeight: 'auto'}}>
                                                            <input 
                                                                className="form-check-input" 
                                                                type="radio" 
                                                                name={`source-${scriptId}`} 
                                                                id={`source-${scriptId}-${src.id}`}
                                                                checked={src.default}
                                                                disabled={fTSel.process}
                                                                onChange={() => handleRadioChange(scriptId, 'source', src.id)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`source-${scriptId}-${src.id}`}>
                                                                {src.filetypeName}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </td>
                                        <td className="align-middle">
                                            <div>
                                                {s.target && s.target.map((tgt, tgtIdx) => {
                                                    return (
                                                        <div key={tgtIdx} className="form-check" style={{minHeight: 'auto'}}>
                                                            <input
                                                                className="form-check-input" 
                                                                type="radio" 
                                                                name={`target-${scriptId}`} 
                                                                id={`target-${scriptId}-${tgt.id}`}
                                                                checked={tgt.default}
                                                                disabled={fTSel.process}
                                                                onChange={() => handleRadioChange(scriptId, 'target', tgt.id)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`target-${scriptId}-${tgt.id}`}>
                                                                {tgt.filetypeName}
                                                            </label>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                    </tbody>
                </table>
            </div>
        </AMModal>
    }
    <button title="Map Filetypes" 
        style={{borderRadius: '0px 4px 4px 0px', marginLeft: '-1px'}}
        className="btn btn-outline-primary btn-sm"
        onClick={preRequest}>
            <SettingsInputCompositeIcon style={{position: 'relative', top: '-2px', fontSize: '14px'}} />
    </button></>
})

// Navigation Toolbar - appears on hover at top of screen
export const NavigationToolbar = () => {
    const [showNav, setShowNav] = useState(false);
    const [canGoBack, setCanGoBack] = useState(false);
    const [canGoForward, setCanGoForward] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            // Show toolbar if mouse is within 50px of top
            setShowNav(e.clientY < 30);
        };

        // Check navigation state periodically
        const checkNavState = () => {
            if(window?.electronAPI?.canGoBack) {
                window.electronAPI.canGoBack().then(setCanGoBack);
            }
            if(window?.electronAPI?.canGoForward) {
                window.electronAPI.canGoForward().then(setCanGoForward);
            }
        };

        window.addEventListener('mousemove', handleMouseMove);
        
        // Check nav state on mount and when shown
        checkNavState();
        const interval = setInterval(checkNavState, 1000);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            clearInterval(interval);
        };
    }, []);

    const handleGoBack = () => {
        if(window?.electronAPI?.goBack) {
            window.electronAPI.goBack();
        }
    };

    const handleGoForward = () => {
        if(window?.electronAPI?.goForward) {
            window.electronAPI.goForward();
        }
    };

    const handleReload = () => {
        if(window?.electronAPI?.reload) {
            window.electronAPI.reload();
        }
    };

    if(!window?.electronAPI?.isElectronContainer) return null;

    return (
        <div 
            className="position-fixed top-0 start-50 bg-white shadow-lg rounded-bottom p-2 d-flex"
            style={{
                zIndex: 9999,
                transform: `translateX(-50%) translateY(${showNav ? '0' : '-100%'})`,
                transition: 'transform 0.3s ease-in-out',
                backdropFilter: 'blur(10px)',
                gap: '8px'
            }}
        >
            <button 
                onClick={handleReload}
                title="Reload Page (F5)"
                className="btn btn-success btn-sm d-flex align-items-center"
            >
                <RefreshIcon style={{fontSize: '18px'}} />
            </button>
            <button 
                onClick={handleGoBack}
                disabled={!canGoBack}
                title="Go Back"
                className={`btn btn-sm d-flex align-items-center gap-1 ${canGoBack ? 'btn-primary' : 'btn-secondary'}`}
            >
                <ArrowBackIcon style={{fontSize: '18px'}} />
                <span className="small">Back</span>
            </button>
            <button 
                onClick={handleGoForward}
                disabled={!canGoForward}
                title="Go Forward"
                className={`btn btn-sm d-flex align-items-center gap-1 ${canGoForward ? 'btn-primary' : 'btn-secondary'}`}
            >
                <span className="small">Forward</span>
                <ArrowForwardIcon style={{fontSize: '18px'}} />
            </button>
        </div>
    );
};
